
/* injects from baggage-loader */

'use strict';

import AddCardController from './add-card.controller';
import AddCardTemplate from './add-card.html';

export default class AddCardComponent {
		constructor() {
				this.templateUrl = AddCardTemplate;
				this.controller = AddCardController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					cardData: '<',
					showControls: '='
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/components/add-card/add-card.component.js